import dayjs from 'lib/dayjs';
import { useCallback, useMemo } from 'react';
import { useTranslate } from '@tolgee/react';

export const getLocalTimeZone = () => -Math.round(new Date().getTimezoneOffset() / 60);

export const isToday = (timestamp: number, timeZone: number) =>
  dayjs(timestamp).utcOffset(timeZone).isSame(dayjs().utcOffset(timeZone), 'days');

export const utcRender = (timeZone: number = getLocalTimeZone()) =>
  `UTC${timeZone === 0 ? '' : `${timeZone > 0 ? '+' : ''}${timeZone}:00`}`;

export function useTimeZoneLabel() {
  const { t } = useTranslate();

  const timeZoneList = useMemo(
    () =>
      new Array(25)
        .fill(0)
        .map((_, index) => index - 12)
        .reverse(),
    [],
  );

  const timeZoneRegionsMap: Record<number, string[]> = useMemo(() => {
    return {
      1: [t('Warsaw')],
      7: [t('jakarta'), t('Bangkok'), t('HanoiCity')],
      8: [t('Beijing')],
      [-3]: [t('brasilia')],
      [-5]: [t('Mexico'), t('bogota')],
    };
  }, [t]);

  const timeZoneRender = useCallback(
    (timeZone: number, showRegion = true) => {
      const label = t(`timeZone${timeZone}`);

      const utc = utcRender(timeZone);

      const regions = timeZoneRegionsMap[timeZone];

      const suffix = showRegion && regions ? `-${regions.join('\\')}` : '';

      return `${label}(${utc})${suffix}`;
    },
    [t, timeZoneRegionsMap],
  );

  return {
    timeZoneList,
    timeZoneRegionsMap,
    timeZoneRender,
    t,
  };
}
